<template>
  <!-- 房间筛选弹窗 -->
  <div class="reserveSeat">
    <el-dialog
      class="reserve-seat-box"
      :visible.sync="show"
      width="450px"
      title="座位预约"
      :close-on-click-modal="true"
      :show-close="false"
      center
    >
      <span slot="footer"></span>
      <span slot="title"></span>
      <div class="filtrate-wrap" @click.stop>
        <div class="filtrate-content-wrap">
          <div class="title-wrap title-op">
            <div>
              {{ $t('tab.orders') }}
              <span class="seatNum">{{ seat && seat.label }}{{ $t('detail.number')}}</span>
            </div>
            <div v-if="isjdZL && seat && seat.status == 'IN_USE' && jdzlCount > 0" class="jd" @click="jdZL">
              <i class="el-icon-warning-outline"></i>
              <span>{{ $t('detail.jdzl') }}</span>
            </div>
            <i v-else class="el-icon-circle-close" @click="show = false" />
          </div>
          <div class="timeLine">
            <div class="freeContainer">
              <div
                class="free"
                v-for="(free, index) in freeList"
                :style="{ width: free.width + '%', left: free.left + '%' }"
                :key="index"
              ></div>
            </div>
            <div class="markLists">
              <div v-for="(item, index) in markList" :style="{ left: item.left - 4.5 + '%' }" :key="index">{{ item.label }}</div>
            </div>
          </div>
          <div class="container-wrap" v-if="mode == '0'">
            <div class="time-filter-wrap">
              <div class="filter-wrap">
                <div class="star-time-wrap time-word">
                  <div class="title">{{ $t('detail.startTime') }}：</div>
                  <div class="word-wrap">
                    <el-select v-model="search.starTimeValue" :placeholder="$t('home.startTimePlaceholder')">
                      <el-option v-for="item in startTimes" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                    <i class="el-icon-time"></i>
                  </div>
                </div>
                <div class="end-time-wrap time-word">
                  <div class="title">{{ $t('detail.endTime') }}：</div>
                  <div class="word-wrap">
                    <el-select v-model="search.endTimeValue" :placeholder="$t('home.endTimePlaceHolder')">
                      <el-option v-for="item in endTimes" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                    <i class="el-icon-time"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="time-filter-wrap" v-if="mode == '1'">
            <div class="time-title-wrap">{{$t('detail.timeScreening')}}</div>
            <div class="filter-wrap sdList">
              <template v-if="timeSlices.length">
                <div
                  class="sd"
                  :class="{ select: selectTimeSplice == item[3] }"
                  v-for="(item, index) in timeSlices"
                  :key="index"
                  @click="selectTimeSlice(item)"
                >{{ item[3] }}</div>
              </template>
              <template v-else>
                <div class="no-time">{{ $t('detail.noAvailable') }}</div>
              </template>
            </div>
          </div>
          <div class="buttons-wrap">
            <div class="btn-wrap cancel" @click="show = false">{{ $t('common.cancel') }}</div>
            <div class="btn-wrap confirm" @click="codeCheck">{{ $t('common.yes') }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 验证码 -->
    <el-dialog class="checkContainer" :visible.sync="showCodeCheck" :close-on-click-modal="true" :show-close="false" center>
      <div class="show-code-check-wrap" id="show-code-check-wrap" @click.stop></div>
    </el-dialog>

    <!-- 预约成功弹窗 -->
    <el-dialog
      class="orderSuccess"
      :visible.sync="orderSuccess"
      width="450px"
      title="预约成功"
      :close-on-click-modal="true"
      :show-close="false"
      center
    >
      <div class="order-success-wrap" @click.stop>
        <div class="order-success-content-wrap">
          <div class="tpp">{{ orderObj.message }}</div>
          <div class="popup-info-wrap">
            <div class="info-item-wrap">
              <div class="title-wrap">{{ $t('orderSeat.orderDate') }}：</div>
              <div class="content-wrap">{{ orderObj.makeDateStr }}</div>
            </div>
            <div class="info-item-wrap">
              <div class="title-wrap">{{ $t('orderSeat.orderTime') }}：</div>
              <div class="content-wrap">{{ orderObj.makeBeginStr }}~{{ orderObj.makeEndStr }}</div>
            </div>
            <div class="info-item-wrap">
              <div class="title-wrap">{{ $t('orderSeat.orderLocation') }}：</div>
              <div class="content-wrap">
                {{ orderObj.location ? (orderObj.location.split('|')[1] + ' ' +
                orderObj.location.split('|')[2]) : '---'
                }}
              </div>
            </div>
            <div class="info-item-wrap">
              <div class="title-wrap">{{ $t('orderSeat.orderSeat') }}：</div>
              <div class="content-wrap">{{ orderObj.seatLabel ? orderObj.seatLabel : '---' }}</div>
            </div>
          </div>
          <div class="button-wrap">
            <div class="button" @click="$router.push({ path: '/main/my' })">
              {{ $t('orderSeat.viewRecords')
              }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTimeLine, getSeatLayout, freeSeatIdsDuration, freeSeatIdsSlice, getStartTimes, getMakeSlices, getEndTimes, freeBook, currentUseMake, checkHigh } from '@/api/index'
import '@/assets/css/tac.css';
import utils from '@/lib/utils'
import SeatPreview from '@/lib/seatPreview'

export default {
  props: {
    date: {}, // 日期
    dateType: {}, // 模式，普通 or 固定
    isjdZL: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      jdzlCount: false,
      seat: {},
      systemInfo: {},
      selectTimeSplice: '',
      search: {
        starTimeValue: '',
        endTimeValue: '',
        minMinutes: ''
      },
      mode: '',
      markList: [],
      freeList: [],

      timeSlices: [],
      startTimes: [],
      endTimes: [],

      showCodeCheck: false,
      orderSuccess: false,

      orderObj: {},
    }
  },
  watch: {
    mode (val) {
      this.mode = val
    },
    'search.starTimeValue': {
      handler (v1, v2) {
        this.search.starTimeText = utils.minuteToHHmm(v1)
        this.getEndTimeByStartime()
      },
      deep: true
    }
  },
  created () {
    let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
    this.jdzlCount = parseInt(systemInfo.superviseAway) > 0
    this.systemInfo = systemInfo
  },
  methods: {
    open (item) {
      this.show = true
      this.seat = item
      this.resetData()
      if (!this.isjdZL) this.mode = item.markMode
      this.getTimelineFun()

      // 获取时间选择
      if (this.mode == 0) {
        this.getStartTimeByMinTime()
      } else {
        this.getTimeSlice()
      }
    },
    resetData () {
      this.timeSlices = []
      this.startTimes = []
      this.endTimes = []
      this.search = {
        starTimeValue: '',
        endTimeValue: '',
        minMinutes: ''
      }
    },
    jdZL () { },
    selectTimeSlice (time) {
      let timeText = time[3]
      this.selectTimeSplice = timeText
      let texts = time[3].split(' _ ')
      this.search.starTimeValue = time[0]
      this.search.endTimeValue = time[1]
      this.search.starTimeText = texts[0]
      this.search.endTimeText = texts[1]
    },
    //常用座位---加载空闲时间轴
    getTimelineFun () {
      getTimeLine(this.seat.id, this.date).then(res => {
        if (res.data.status) {
          this.freeList = res.data.data.freeList
          this.markList = res.data.data.markList
        }
      })
    },


    //获取固定时间段
    getTimeSlice () {
      getMakeSlices(this.seat.id, this.date).then(res => {
        if (res.data.status) {
          this.timeSlices = res.data.data
        }
      })
    },
    //获取时间选择
    getStartTimeByMinTime () {
      getStartTimes(this.seat.id, this.date).then(res => {
        if (res.data.status) {
          let startTime = res.data.data;
          this.startTimes = startTime.map((item, index) => {
            if (index == 0) {
              this.search.starTimeText = item[1]
              this.search.starTimeValue = item[0]
            }
            return {
              text: item[1],
              value: item[0]
            }
          })
        }
      })
    },
    //根据开始时间获取结束时间
    getEndTimeByStartime () {
      let startTimeValue = this.search.starTimeValue == 'now' ? utils.hhmmToMinute('now') : this.search.starTimeValue
      if (!startTimeValue) return
      getEndTimes(this.seat.id, this.date, startTimeValue).then(res => {
        if (res.data.status) {
          let endTime = res.data.data;
          this.endTimes = endTime.map((item, index) => {
            return {
              text: item[1],
              value: item[0]
            }
          })
        }
      })
    },


    // 判断是否需要验证码
    openCaptcha (mackCaptcha, yesCallBack, noCallBack) {
      if (mackCaptcha == 0) {//无需加载验证码
        noCallBack();
      } else if (mackCaptcha == 2) {//直接加载
        yesCallBack();
      } else {
        checkHigh().then(res => {//当前时段是否为高峰期
          if (res.data.status) {
            if (res.data.data) {//只有高峰期才可以加载
              yesCallBack();
            } else {
              noCallBack();
            }
          } else {
            Vue.prototype.$toast(res.data.message)
          }
        }).catch(err => {
          console.error(`获取当前是否为高峰期异常Error:${err}`);
          Vue.prototype.$toast("服务异常，请联系管理员")
        })
      }
    },
    // 预约
    codeCheck: function () {
      let userInfo = JSON.parse(sessionStorageProxy.getItem("userInfo"))
      let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'));
      this.openCaptcha(systemInfo.mackCaptcha,
        () => {
          this.show = false
          this.showCodeCheck = true
          this.$nextTick(() => {
            // 英文
            var us = {
              tips_success: "Verification successful",
              tips_error: "Validation failed",
              tips_4001: "try again",
              image_click_title: "Select in this order:",
              scrape_title_before: "Drag slider display",
              scrape_title_after: "let go",
              word_order_image_title: "Click on the text in word order",
              rotate_degree_title: "Drag the slider to make the angle positive",
              slider_title: "Slide to complete the puzzle",
              concat_title: "Slide to complete the puzzle",
              rotate_title: "Slide to complete the puzzle",
              image_click_title_size: "16px",
              word_order_image_title_size: "18px",
              rotate_degree_title_size: "14px",
            }

            // 全局配置RSA公钥， 最好自己重新生成一份， 该行代码最好用JS进行加密, 全局设置一次即可
            TAC.enc.rsaPublicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXRMEk7baUetStHq6IPIxwKB9ga9UyCepDEEFIZUS5cc1/FyS90Tbd1VA4j+AfqurclfBHUWgvuzAj4oW5b/sdS1SC14259tLexFbT5EfPsyY0BPfMXkzUerSbzgL8ZIUtHfHV1z6/WA6iHVmB1SpWT2BwaE9Alednp9EO8dLQvQIDAQAB";
            let API_ADDRESS = process.env.NODE_ENV == "production" ? Global.BASEURL : "/api";
            const config = {
              requestCaptchaDataUrl: API_ADDRESS + "/static/cap/cg/gen/SLIDER",
              validCaptchaUrl: API_ADDRESS + "/static/cap/cg/check",
              // 绑定的div
              bindEl: "#show-code-check-wrap",
              customData: {
                username: userInfo.username
              },
              // 验证成功回调函数
              validSuccess: (res, c, t) => {
                console.log("验证码验证成功回调...")
                // 销毁验证码
                t.destroyWindow();
                this.showCodeCheck = false
                this.confirmFilter(res.data.token)
              },
              // 验证失败回调函数
              validFail: (res, c, t) => {
                console.log("验证码验证失败回调...")
                t.reloadCaptcha();
              },
              // 刷新按钮回调事件
              btnRefreshFun: (el, tac) => {
                console.log("刷新按钮触发事件...")
                tac.reloadCaptcha();
              },
              // 关闭按钮回调事件
              btnCloseFun: (el, tac) => {
                this.showCodeCheck = false
                tac.destroyWindow();
              }
            }
            // 样式配置, 用于配置logo和按钮相关样式
            const style = {
              i18n: this.$i18n.locale === 'en' ? us : null
            }
            new TAC(config, style).init();
          })
        }, () => {
          this.confirmFilter()
        });
    },
    confirmFilter (token = 'capToken') {
      if (this.search.endTimeValue == '') {
        return this.$warning(this.$t('home.endTimePlaceHolder'))
      }
      let param = { seatId: this.seat.id, makeDate: this.date, startMinute: this.search.starTimeValue == 'now' ? utils.hhmmToMinute(this.search.starTimeValue, true) : this.search.starTimeValue, endMinute: this.search.endTimeValue, capToken: token }
      freeBook(param).then(res => {
        if (res.data.status) {
          this.orderObj = res.data.data
          this.orderSuccess = true
          this.show = false
          this.getCurrentBook()
        } else {
          this.$warning(res.data.message)
        }
      }).catch(err => {
        this.$warning(this.$t('common.error'))
      })
    },

    //获取当前
    getCurrentBook () {
      currentUseMake().then(res => {
        if (res.data.status) {
          let currentBook = res.data.data == null ? {} : res.data.data
          sessionStorageProxy.setItem("currentBook", JSON.stringify(currentBook))
        } else {
          this.$warning(res.data.message)
        }
      }).catch(err => {
        console.error(`获取当前有效预约Error:${err}`);
        this.$warning("服务异常，请联系管理员")
      })
    }
  },
}
</script>

<style lang="less">
.reserve-seat-box {
  .el-dialog {
    border-radius: 10px;
    width: 400px !important;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0px !important;
    border-radius: 10px;
  }

  .el-dialog__footer {
    padding: 0px !important;
  }
}
</style>
<style lang="less" scoped>
.orderSuccess {
  &/deep/.el-dialog {
    border-radius: 10px;
    width: 450px !important;
    border: none;
    background: none !important;
  }

  &/deep/.el-dialog__header {
    display: none !important;
  }

  &/deep/.el-dialog__body {
    padding: 0px !important;
    border-radius: 10px;
  }

  &/deep/.el-dialog__footer {
    padding: 0px !important;
  }
}

.checkContainer {
  &/deep/.el-dialog {
    border-radius: 10px;
    width: 318px !important;
    border: none;
    background: none !important;
  }

  &/deep/.el-dialog__header {
    display: none !important;
  }

  &/deep/.el-dialog__body {
    padding: 0px !important;
    border-radius: 10px;
  }

  &/deep/.el-dialog__footer {
    padding: 0px !important;
  }
}

.reserve-seat-box {
  // 筛选条件弹窗
  .filtrate-wrap {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .filtrate-content-wrap {
      background: linear-gradient(to bottom, #e6eeff, white);
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      .timeLine {
        width: 100%;
        padding: 0px 20px 10px;
        box-sizing: border-box;
        margin-top: 25px;

        .freeContainer {
          width: 100%;
          background-color: #f55858;
          height: 8px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          div {
            background-color: #69bb69;
            height: 100%;
            position: absolute;
          }
        }

        .markLists {
          position: relative;
          width: 100%;
          height: 20px;
          margin-top: 4px;

          div {
            position: absolute;
            font-size: 0.8rem;
            width: 3rem;
          }
        }
      }

      .bg {
        width: 60%;
        margin: 0 auto;
      }

      .title-wrap {
        width: 100%;
        height: auto;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 500;
        color: #333;
        padding: 30px 0 15px 0;
        border-bottom: 1px solid #efefef;
        padding-bottom: 0px;

        .seatNum {
          margin-left: 5px;
          font-size: 0.85rem;
        }

        &.title-op {
          padding-left: 15px !important;
          padding-right: 15px !important;
          display: flex;
          justify-content: space-between !important;
          align-items: baseline !important;
          box-sizing: border-box;

          div:last-child {
            font-size: 15px;
            color: #acaebf;
          }

          i {
            font-size: 25px;
            margin-right: 3px;
          }
        }
      }

      .container-wrap {
        flex: 1;
        width: 100%;
        padding: 0px 20px 10px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-bottom: 20px;
      }

      .time-filter-wrap {
        width: 100%;
      }

      .time-title-wrap,
      .other-title-wrap {
        text-align: left;
        color: #7f7f7f;
        font-size: 15px;
      }
      .time-title-wrap {
        padding-left: 10px;
      }

      .other-title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .filter-wrap {
          width: 65% !important;
          flex: unset !important;
          padding-right: 0;
          position: absolute;
          right: 0;

          &/deep/.van-checkbox__icon {
            font-size: 18px;
          }
        }
      }

      .other-filter-wrap .filter-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        flex: 1;
        justify-content: space-between;
      }

      .other-filter-wrap {
        margin-top: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
      }

      .filter-wrap {
        width: 100%;
        margin: auto;
        padding: 10px 0 10px 0;
        box-sizing: border-box;

        &.sdList {
          display: flex;
          justify-content: space-between;
          padding-left: 0;
          padding-right: 0;
          flex-direction: row;
          flex-wrap: wrap;
          text-align: center;
          padding: 0 10px;

          .sd {
            width: 47%;
            color: #000;
            font-size: 15px;
            background-color: #f0f0f0;
            border-radius: 5px;
            border: 1px solid #ccc;
            margin-bottom: 5px;
            padding: 10px 0;

            &.select {
              color: #3673fe;
              background-color: #e3edff;
              border: 1px solid #3673fe;
            }
          }
        }

        .title {
          color: #666;
          text-align: left;
          width: 100%;
          font-size: 15px;
        }

        .word-wrap {
          font-size: 15px;
          color: #666;
          flex: 1;
          text-align: center;
          border-bottom: 1px solid #edeffeed;
          background-color: white;
          padding: 10px;
          box-sizing: border-box;
          width: 100%;
          border-radius: 5px;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          i {
            font-size: 25px;
            color: #3a3a3a;
            margin-left: 10px;
          }

          .el-select {
            width: 100%;
          }
        }

        .minutesInput {
          width: 100%;
          outline: none;
          border: none;
        }

        .time-word {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: column;
        }

        .end-time-wrap {
          margin-top: 15px;
        }

        .no-time {
          width: 100%;
          padding: 5px 0 15px 0;
          font-size: 12px;
          text-align: center;
          color: #7f7f7f;
        }
      }

      .buttons-wrap {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-top: 2px solid #ececec;
        padding: 20px 0 20px 0;
      }

      .cancel {
        border-right: 1px solid #ececec;
        color: #8a8a8a;
      }

      .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        font-size: 16px;
      }

      .confirm {
        color: #006bff;
      }
    }
  }
}

// 预约成功弹窗
.order-success-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .order-success-content-wrap {
    width: 85%;
    background-image: url('~@/assets/images/popup-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    padding-top: 50%;
    padding-bottom: 20px;

    .tpp {
      font-size: 15px;
      text-align: center;
      color: #5f84f3;
      margin-top: 15px;
    }
  }

  .notice-wrap {
    margin-top: 387px;
    font-size: 28px;
    width: 100%;
    text-align: center;
    font-weight: 500;
    color: #5d80f2;
  }

  .popup-info-wrap {
    flex: 1;
    overflow: auto;
    padding: 20px 10%;
    display: flex;
    flex-direction: column;

    .info-item-wrap {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      justify-content: space-between;

      .title-wrap {
        font-size: 14px;
        font-weight: 400;
        color: #656f85;
        min-width: 35%;
      }

      .content-wrap {
        font-size: 15px;
        font-weight: 500;
        color: #161921;
      }
    }
  }

  .button-wrap {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .button {
      width: 77%;
      height: 100%;
      background: #5d80f2;
      border-radius: 40px 40px 40px 40px;
      font-size: 15px;
      font-family: Source Han Sans SC-Regular, Source Han Sans SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reserveSeat.vue